import { omit } from 'lodash';
import { Button, ButtonProps } from 'reactstrap';
import './BaseButton.scss';

export type BaseButtonProps = ButtonProps & {
    isPending?: boolean;
};

const BaseButton = (props: BaseButtonProps) => {
    return (
        <Button
            className={`${props.className ?? ''} ${props.isPending ? 'loading' : ''}`}
            disabled={props.disabled || props.isPending}
            {...omit(props, 'lableCode', 'isPending', 'children')}
        >
            <div className="base-button__root">
                <div>{props.children}</div>
            </div>
        </Button>
    );
};

export default BaseButton;
